import React from 'react'
// components
import BusinessActivitiesAPI from 'containers/BusinessActivities/layers/API/index'
import BusinessActivities from 'components/PageComponents/Settings/BusinessActivities/index'

const BusinessActivitiesContainer: React.FC = () => {
  return (
    <BusinessActivitiesAPI>
      <BusinessActivities />
    </BusinessActivitiesAPI>
  )
}

export default BusinessActivitiesContainer
